<template>
    <div class="modal">
        <div class="modal-content">
            <div class="panel">
                <div class="panel-heading">
                    <h2>{{meetingType}} Check-in 
                        <span v-if="alert.global_meeting && alert.global_meeting.startTime">
                            &mdash; {{alert.global_meeting.startTime | timelineDate}}
                        </span> </h2>                    
                    <h5 v-if="alert.global_meeting && alert.global_meeting.mentor">
                        {{alert.global_meeting.mentor.firstName}} {{alert.global_meeting.mentor.lastName}} 
                        - 
                        <span v-if="alert.global_meeting && alert.global_meeting.startTime">
                            {{alert.global_meeting.startTime | dayMonthYear}}
                        </span>
                    </h5>

                </div>
                <div class="panel-body">
                    <form @submit.prevent="submitCheckin()">
                        <div class="form-group">
                            <label>How did the live session go?</label>
                            <select v-model="checkin.overall" class="form-control">
                                <option v-for="option in options" :value="option">{{option}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Is there anything on your mind that you'd like to share?</label>
                            <textarea class="form-control" v-model="checkin.comments"></textarea>
                        </div>
                        <div v-if="localStorage.roles.includes('GlobalMentor') || localStorage.roles.includes('Recruiter')">
                            <div class="form-group">
                                <label>Did you have enough time to cover all the questions?</label>
                                <label><input type="radio" v-model="checkin.sufficientTime" name="sufficient_time" value="true">Yes</label>
                                <label><input type="radio" v-model="checkin.sufficientTime" name="sufficient_time" value="false">No</label>
                            </div>
                            <div class="form-group" v-if="checkin.sufficientTime == 'false'">
                                <label>If no, please explain </label>
                                <textarea class="form-control" v-model="checkin.timeExplanation"></textarea>
                            </div>
                        </div>
                        <div v-else>
                            <div class="form-group">
                                <label>How knowledgeable was your {{meetingType}}?</label>
                                <select v-model="checkin.knowledgeRating" class="form-control">
                                    <option v-for="option in options" :value="option">{{option}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>How organized was your {{meetingType}}?</label>
                                <select v-model="checkin.organizationRating" class="form-control">
                                    <option v-for="option in options" :value="option">{{option}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="checkbox" v-model="checkin.important">
                            Mark this as important for Think Tank staff to see and be notified.
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-success">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import globalMeetings from '../../services/global-meetings';

import toastr from 'toastr';

export default {
    props: ['alert'],
    data() {
        return {
            checkin: {
                overall: null,
                comments: null,
                knowledgeRating: null,
                organizationRating: null,
                sufficientTime: null,
                timeExplanation: null,
                important: null
            },
            options: ['Excellent', 'Good', 'Not Great', 'Bad']
        }
    },
    components: {

    },
    mounted() {

    },
    methods: {
        validateCheckin() {
            const checkin = this.checkin;


            if (!checkin.overall) {
                toastr.error('Please let us know how the live session went');
                return false;
            }

            if (localStorage.roles.includes('GlobalMentor') || localStorage.roles.includes('Recruiter')) {
                if (!checkin.sufficientTime) {
                    toastr.error('Please fill out the form completely');
                    return false;
                }
                if (checkin.sufficientTime && checkin.sufficientTime === 'false' && !checkin.timeExplanation) {
                    toastr.error('Please fill out the form completely');
                    return false;
                }
            } else if (localStorage.roles.includes('Student')) {
                if (!checkin.knowledgeRating || !checkin.organizationRating) {
                    toastr.error('Please rate your experience with the mentor');
                    return false;
                }
            }

            return true;
        },
        submitCheckin() {
            const valid = this.validateCheckin();

            if (valid === true) {

                const checkin = this.checkin;
                checkin.globalMeetingId = this.alert.globalMeetingId;
                checkin.alertId = this.alert.id;
                globalMeetings.submitCheckin(checkin).then((response) => {
                    if (response.data.success === true) {
                        toastr.success('Submitted');
                        this.$emit('reload');
                    } else {
                        toastr.error('Error submitting checkin');
                    }
                });
            }
        }
    },
    computed: {
        meetingType() {
            if (this.alert.global_meeting.mentor.roles.includes('GlobalMentor')) {
                return 'Global Mentor';
            }
            if (this.alert.global_meeting.mentor.roles.includes('Recruiter') || this.alert.global_meeting.mentor.roles.length === 1) {
                return 'Recruiter';
            }
            return 'Global Mentor';
        }
    }
}

</script>
<style lang="scss" scoped>
form {
    padding: 1rem 3rem;
}

.modal {
    display: flex;
    z-index: 99999999999999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
    align-items: center;
    justify-content: center;

    .modal-content {}
}

</style>



// WEBPACK FOOTER //
// GlobalCheckin.vue?3dc1b5d3